import React, { useState, useEffect } from "react";
import { login } from "../store/actions/authActions";
import { verify2FA } from "../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link } from "react-router-dom";
import { Redirect } from 'react-router-dom';

import Avatar from '../assets/images/profile.png';
import LOADER from "../assets/images/loader.svg";






function Login(props) {


  const { token, loginFN, errore, verify2FAFN} = props;
  const [show2FA, setShow2FA] = useState(false);
  const [username, setusername] = useState(null);
  const [pwd, setpwd] = useState(null);
  const [loading, setloading] = useState(false);
  const [code, setCode] = useState(null);
  

  useEffect(() => {
    if (token || errore) {
      setloading(false);
    }
  }, [token, errore]);

  const handle2FAVerify = (e) => {
    e.preventDefault();
    setloading(true);
    verify2FAFN(username, code); 
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    loginFN(
      username,
      pwd,
      () => setShow2FA(true)
    );
  };


  return token ? <Redirect to="/risk" /> : ( show2FA ? (
    <div style={styles.container}> 
    <form onSubmit={handle2FAVerify} style = {styles.form}>
    <img src={Avatar} style={{ transform: 'scale(0.4)', transformOrigin: 'center' }} ></img>
      <p style = {styles.written}> We have sent a email to <strong>{username}</strong></p>
          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            style={styles.heading}
          />
          
          <button type="submit" style={styles.button}>Verify</button>
          <p style={styles.link} >Resent email</p>
          {errore ? <p className="text-red-500 mb-4 text-center">{errore}</p> : null}
        </form>
        </div>
        
  ) :
    <div className="mt-16">
      <div className="flex justify-center mb-3 bg-white rounded-lg">
        <div className="w-full max-w-md p-4 text-black">
          <form onSubmit={handleSubmit}>
            <div className="h-2"></div>

            <div className="flex justify-center">
              <Link to="/">
                <h1 className="text-3xl font-bold">Rabo</h1> {/* Increased logo size */}
              </Link>
            </div>
            <div className="h-10"></div>

            <h1 className="text-center text-1xl font-bold">Sign in to your account:</h1>

            <div className="h-8"></div>
            <div className="mb-4">
              <div className="relative">
                <input
                  required
                  className="input block w-full p-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500" // Added padding-left to input
                  type="text"
                  placeholder="Enter your e-mail address"
                  id="username"
                  name="username"
                  onChange={(v) => {
                    setusername(v.target.value);
                  }}
                  value={username || ""}
                />
                <span className="absolute left-3 top-2.5 text-gray-500"> {/* Added padding to icon */}
                  <i className="fas fa-user"></i>
                </span>
              </div>
            </div>

            <div className="mb-4">
              <div className="relative">
                <input
                  required
                  className="input block w-full p-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-500" // Added padding-left to input
                  type="password"
                  placeholder="Enter your password"
                  id="pwd"
                  name="pwd"
                  onChange={(v) => {
                    setpwd(v.target.value);
                  }}
                  value={pwd || ""}
                />
                <span className="absolute left-3 top-2.5 text-gray-500"> {/* Added padding to icon */}
                  <i className="fas fa-key"></i>
                </span>
              </div>
            </div>

            <div className="mb-4">
              <button
                className="w-full py-2 text-white font-semibold bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none button-main"
                type="submit"
                disabled={loading}
              >
                {loading ? <img src={LOADER} alt="Loading..." className="w-6 h-6  mx-auto" /> : "Sign in"}
              </button>
              <div className="h-2"></div>
            </div>

            {errore ? <p className="text-red-500 mb-4 text-center">{errore}</p> : null}
          </form>


          <div className="h-1"></div>
          <hr className="p-2" />
          <p className="text-center">
            Forgot your password? Click <Link to="/recovery" className="text-black font-semibold">here</Link> to reset it.
          </p>
        </div>
      </div>
    </div>
  );

}

const mapStateToProps = (state) => {
  return {
    errore: state.auth.errore,
    token: state.auth.token,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginFN: (username, pwd, callback) =>
      dispatch(login(username, pwd, callback)),
    verify2FAFN: (username, code) =>
      dispatch(verify2FA(username, code)),
  };
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center',     
    height: '100vh',         
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    margin: '0 auto',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    background: '#fff',
    alignItems: 'center'
  },
  heading: {
    marginBottom: '20px',
    textAlign: 'center',
    fontSize: '15px',
    fontWeight: 'bold',
  },
  written: {
    textAlign: 'center',
    fontSize: '12px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  button: {
    padding: '10px',
    fontSize: '16px',
    backgroundColor: '#0A4E62',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 'bold',
  },
};



export default compose(connect(mapStateToProps, mapDispatchToProps))(Login);